export function limitLength(str = "", maxLength = 50) {
  if (str.length <= maxLength) {
    return str;
  }

  return `${str.substring(0, maxLength - 3)}...`;
}

export function capitalizeWord(inputStr = "") {
  if (!inputStr || typeof inputStr !== "string") {
    return "";
  }

  const first = inputStr.substring(0, 1);
  const rest = inputStr.substring(1);

  return `${first.toLocaleUpperCase()}${rest.toLocaleLowerCase()}`;
}

export function titleCase(sentence = "") {
  if (!sentence || typeof sentence !== "string") {
    return "";
  }

  return sentence.split(/\s+/).map(capitalizeWord).join(" ");
}

// Join english words with commas and "and" in the last one
export function joinEnglish(...words) {
  if (!words || !words.length) {
    return "";
  }

  let [first] = words;

  if (Array.isArray(first)) {
    // eslint-disable-next-line no-param-reassign
    words = first;
    [first] = words;
  }

  if (typeof first !== "string") {
    return "";
  }

  if (words.length === 1) {
    return first;
  }

  const last = words.pop();
  return `${words.join(", ")} and ${last}`;
}

// Pluralize english words
export function pluralizeEnglish(word = "", count = 1) {
  if (!word || typeof word !== "string") {
    return "";
  }

  if (count === 1) {
    return word;
  }

  if (word.endsWith("s")) {
    return `${word}es`;
  }

  // Only a consonant before the y takes -ies; a vowel keeps it ("days", "keys").
  if (/[^aeiou]y$/i.test(word)) {
    return `${word.slice(0, -1)}ies`;
  }

  return `${word}s`;
}

export function joinEnglishReducer(currentPhrase, currentWord, index, array) {
  if (index === 0) {
    return currentWord;
  }

  if (index === array.length - 1) {
    return `${currentPhrase} and ${currentWord}`;
  }

  return `${currentPhrase}, ${currentWord}`;
}

/*
 * joinEnglishPick
 *
 * @param {function} picker - A function that takes an element and returns a string
 * @param {array} array - An array of elements
 * @returns {string} - A string of the elements joined with commas and "and" in the last one
 */
export const joinEnglishPick = (picker = (x) => x, array = [], opts = {}) => {
  const { max = Infinity } = opts;

  const words = array.map(picker).filter(Boolean);
  const capped = words.slice(0, Math.max(0, max));
  const remaining = Math.max(0, words.length - capped.length);

  const output = [];

  for (let i = 0; i < capped.length; i += 1) {
    const comma = i < capped.length - 1 ? ", " : "";
    const word = `${capped[i]}${comma}`;
    output.push(word);
  }

  if (remaining > 0) {
    output.push(`and ${remaining} more`);
  }

  return output.join(" ");
};

export const validateEmail = (email) => {
  if (
    email &&
    email.match(
      /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g,
    )
  ) {
    return true;
  }
  return false;
};

export const getInitials = (name = "") =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

export const toCamelCase = (str = "") => {
  return str
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr.toUpperCase());
};

export const countWords = (text) =>
  text && text.trim().length > 0
    ? text.trim().split(/\s+/).filter(Boolean).length
    : 0;
